import React from 'react'
import classNames from 'classnames'
import { Icon } from '@scentregroup/ui'
import style from './index.scss'

interface UtilityBoxItemProps {
  icon?: string
  children?: React.ReactNode
  className?: string
  role?: string
}

const UtilityBoxItem: React.FunctionComponent<UtilityBoxItemProps> = ({
  icon,
  children,
  className,
  ...iconOptions
}) => (
  <div className={classNames(style.UtilityBoxItem, className)}>
    {icon && <Icon className={style.image} type={icon} {...iconOptions} />}
    <div className={style.childWrapper}>{children}</div>
  </div>
)

export default UtilityBoxItem
